import React from 'react';
import Switch from 'antd/lib/switch';
import styled from 'styled-components';
import theme from '@css/theme';

interface Props {
  disabled?: boolean;
  loading?: boolean;
  checked?: boolean;
  onChange: (enabled: boolean) => void;
  defaultChecked?: boolean;
  testid?: string;
}

const StyledSwitch = styled(Switch)`
  opacity: 1;
  &.ant-switch {
    background: ${({ disabled }) => (disabled ? '#e5e5e5' : '#bfbfbf')};
  }
  &.ant-switch-checked {
    background: ${({ disabled }) => (disabled ? '#b3d1ff' : theme.color.rsPrimary)};
  }
`;

export default ({ disabled, loading, onChange, checked, defaultChecked, testid }: Props) => (
  <StyledSwitch
    defaultChecked={defaultChecked}
    disabled={disabled}
    loading={loading}
    onChange={onChange}
    checked={checked}
    data-testid={testid}
  />
);
